import * as React from 'react';
import Checkbox from '@mui/material/Checkbox';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
//import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import PropTypes from 'prop-types';

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

export default function UseAutoCompleteSearch({ data, label, onSelectChange, selected, noOptionsText, search }) {
    const onSelectChanged = (newValue) => {
        if (onSelectChange) {
            onSelectChange(newValue);
        }
    };

    const onInputChange = (event, newValue) => {
        if (search) {
            search(newValue);
        }
    };

    // const OPTIONS_LIMIT = 100;
    // const filterOptions = createFilterOptions({
    //     limit: OPTIONS_LIMIT,
    // });

    return (
        <div style={{ marginBottom: 16 }}>
            <Autocomplete
                ListboxProps={{ style: { maxHeight: '15rem' }, position: 'bottom-start' }}
                multiple
                limitTags={8}
                id="checkboxes-tags-demo"
                options={data}
                disableCloseOnSelect
                noOptionsText={noOptionsText}
                onChange={(event, newValue) => {
                    onSelectChanged(newValue);
                }}
                onInputChange={onInputChange}
                getOptionLabel={(option) => option.label}
                defaultValue={selected}
                renderOption={(props, option, { selected }) => (
                    <li {...props}>
                        <Checkbox icon={icon} checkedIcon={checkedIcon} style={{ marginRight: 2 }} checked={selected} />
                        {option.label}
                    </li>
                )}
                style={{ width: 300, marginTop: 10, paddingRight: 10, maxHeight: 350, overflowY: scroll }}
                renderInput={(params) => (
                    <TextField sx={{ overflowY: scroll }} {...params} label={label} placeholder={label} />
                )}
            />
        </div>
    );
}

UseAutoCompleteSearch.propTypes = {
    data: PropTypes.object.isRequired,
    label: PropTypes.object.isRequired,
    onSelectChange: PropTypes.func.isRequired,
    selected: PropTypes.object.isRequired,
    noOptionsText: PropTypes.object.isRequired,
    search: PropTypes.object.isRequired,
};
